import { PromotionTable } from "@/app/Promotions/Components/PromotionTable";
import { RecordScreenCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenCard";
import { useSupplierRecord } from "@/app/Suppliers/Hooks/useSupplierRecord";
import { useTranslations } from "use-intl";

export function SupplierAdsScreen() {
  const record = useSupplierRecord();
  const t = useTranslations("promotion.ads");

  return (
    <div className="py-6">
      <RecordScreenCard title={t("title")}>
        <PromotionTable id="supplier-ads" supplierId={record.id} />
      </RecordScreenCard>
    </div>
  );
}
